// Base dos itens-hub do menu (FIN-HUBS 2026-07-13, generalizado em COM-HUBS
// 2026-08-21): um item da sidebar agrega várias páginas em abas.
//
// Duas regras que não podem se perder:
//  • a aba ativa vive na URL (?aba=) e os DEMAIS query params são PRESERVADOS,
//    pra os deep-links continuarem valendo (?parcela=, ?situacao=, ?negocio=…
//    — as páginas-filhas leem esses params da mesma location, código intocado);
//  • destroyInactiveTabPane: monta só a aba ativa (tem página de ~2k linhas
//    aqui dentro; montar todas de uma vez trava o navegador).
import { useMemo, ReactElement, ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, Empty } from 'antd';
import { usePerms } from '../hooks/usePerms';

export interface HubTab {
  key: string;
  label: ReactNode;
  perm: string;
  /** Aba restrita a admin mesmo que a perm passe (ex.: Deliberação). */
  soAdmin?: boolean;
  render: () => ReactElement;
}

export default function HubAbas({ tabs }: { tabs: HubTab[] }) {
  const { pode } = usePerms();
  const ehAdmin = pode('admin.permissoes.editar');
  const [sp, setSp] = useSearchParams();

  const visiveis = useMemo(
    () => tabs.filter(t => (t.soAdmin ? ehAdmin : ehAdmin || pode(t.perm))),
    [tabs, ehAdmin, pode]
  );

  if (!visiveis.length) {
    return <div style={{ padding: 24 }}><Empty description="Você não tem acesso a nenhuma página deste grupo." /></div>;
  }

  const pedida = sp.get('aba');
  const activeKey = pedida && visiveis.some(t => t.key === pedida) ? pedida : visiveis[0].key;

  const trocar = (key: string) => {
    const next = new URLSearchParams(sp);
    next.set('aba', key);
    setSp(next, { replace: true });
  };

  const items = visiveis.map(t => ({ key: t.key, label: t.label, children: t.render() }));

  // As abas do hub são CARD sobre uma faixa cinza, de propósito: várias
  // páginas-filhas têm abas próprias (Dashboard, Documentos, Licitações) e,
  // com os dois níveis no mesmo estilo sublinhado, ninguém sabia qual fileira
  // era qual (feedback do Lucas, 2026-08-21). Card + faixa = "em que tela
  // estou"; sublinhado embaixo = "que visão dessa tela".
  return (
    <Tabs
      type="card"
      activeKey={activeKey}
      onChange={trocar}
      items={items}
      destroyInactiveTabPane
      tabBarStyle={{
        margin: 0,
        padding: '10px 16px 0',
        background: '#f5f6f8',
        borderBottom: '1px solid #e3e5ea',
      }}
    />
  );
}
